'use es6';

import { EditableLegalConsentKeys } from 'FormsCommonComponents/constants/LegalConsent';
import { getBusinessUnitId } from 'FormsUI/selectors/FormDefinition';
import { hasBusinessUnitsAccess as getHasBusinessUnitsAccess } from 'FormsUI/selectors/BusinessUnitsAccess';
import { isUngatedForCampaignBusinessUnit as getIsUngatedForCampaignBusinessUnit } from 'FormsUI/selectors/Gates';
import { getUnavailableEmailSubscriptionsIdsByFormBusinessUnit as _getUnavailableEmailSubscriptionsIdsByFormBusinessUnit } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
import { getLegalConsentOptions, getSubscriptionDefinitions } from 'FormsUI/selectors/LegalConsent';
export const getSelectedSubscriptionIds = state => {
  const legalConsent = getLegalConsentOptions(state);
  return legalConsent ? legalConsent.get(EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES).map(({
    communicationTypeId
  }) => communicationTypeId) : [];
};
export const getUnavailableEmailSubscriptionsIdsByFormBusinessUnit = state => {
  const emailSubscriptions = getSubscriptionDefinitions(state);
  const formBusinessUnitId = getBusinessUnitId(state);
  const hasBusinessUnitsAccess = getHasBusinessUnitsAccess(state);
  const isUngatedForCampaignBusinessUnit = getIsUngatedForCampaignBusinessUnit(state);
  return _getUnavailableEmailSubscriptionsIdsByFormBusinessUnit({
    formBusinessUnitId,
    emailSubscriptions,
    hasBusinessUnitsAccess,
    isUngatedForCampaignBusinessUnit
  });
};